import { createAction } from "redux-ts";
import { ErrorPayload } from "../../models";

export const handleError = createAction<ErrorPayload>("ERROR::HANDLE_ERROR");
export const displayError = createAction<ErrorPayload>("ERROR::DISPLAY_ERROR");
export const clearError = createAction<string>("ERROR::CLEAR_ERROR");
export const clearAllErrors = createAction("ERROR::CLEAR_ALL_ERRORS");
